import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "tw-text-sm tw-text-slate-500"
}
const _hoisted_3 = {
  key: 1,
  class: "tw-space-y-6"
}
const _hoisted_4 = { class: "tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-shadow-sm" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-justify-between tw-border-b tw-border-slate-100 tw-px-5 tw-py-4" }
const _hoisted_6 = {
  key: 0,
  class: "tw-grid tw-grid-cols-1 tw-gap-4 tw-border-b tw-border-slate-100 tw-bg-slate-50/60 tw-p-5 md:tw-grid-cols-[1fr_220px_auto] md:tw-items-end"
}
const _hoisted_7 = { class: "tw-flex tw-gap-2" }
const _hoisted_8 = {
  key: 1,
  class: "tw-overflow-x-auto"
}
const _hoisted_9 = { class: "tw-min-w-full tw-divide-y tw-divide-slate-100" }
const _hoisted_10 = { class: "tw-divide-y tw-divide-slate-100" }
const _hoisted_11 = { class: "tw-px-5 tw-py-4 tw-align-middle" }
const _hoisted_12 = {
  key: 0,
  class: "tw-px-5 tw-py-4 tw-align-middle tw-text-sm tw-font-medium tw-text-slate-800"
}
const _hoisted_13 = { class: "tw-flex tw-items-center tw-leading-5" }
const _hoisted_14 = {
  key: 1,
  class: "tw-px-5 tw-py-4 tw-align-middle"
}
const _hoisted_15 = { class: "tw-px-5 tw-py-4 tw-align-middle" }
const _hoisted_16 = {
  key: 0,
  class: "tw-flex tw-justify-end tw-gap-2"
}
const _hoisted_17 = {
  key: 1,
  class: "tw-flex tw-justify-end tw-gap-1.5"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 2,
  class: "tw-p-5 tw-text-sm tw-text-slate-500"
}
const _hoisted_21 = { class: "tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-5 tw-shadow-sm" }
const _hoisted_22 = { class: "tw-text-sm tw-text-slate-700" }
const _hoisted_23 = { class: "tw-font-semibold tw-text-slate-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_EditableInputLabel = _resolveComponent("EditableInputLabel")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.$apollo.queries.contractRates.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Loading rates... "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "tw-text-lg tw-font-semibold tw-text-slate-900" }, "Rates", -1)),
              (!_ctx.isAddingRate)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _ctx.toggleAddContractRate
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Add New Rate ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isAddingRate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_EditableInputLabel, {
                    isEditing: true,
                    label: "City Name",
                    modelValue: _ctx.newRate.destinationCity,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newRate.destinationCity) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_EditableInputLabel, {
                    isEditing: true,
                    label: "Rate Amount",
                    modelValue: _ctx.newRate.amount,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newRate.amount) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Button, {
                      isGreen: true,
                      icon: "check",
                      onClick: _ctx.confirmContractRateAddition
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Save", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_Button, {
                      isRed: true,
                      isSecondary: true,
                      onClick: _ctx.toggleAddContractRate
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("Cancel", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.contractRates && _ctx.contractRates.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("table", _hoisted_9, [
                    _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "tw-bg-slate-50" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "tw-px-5 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, " City "),
                        _createElementVNode("th", { class: "tw-px-5 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, " Charge Rate "),
                        _createElementVNode("th", { class: "tw-px-5 tw-py-3 tw-text-right tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, " Actions ")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractRates, (rate) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: rate.id,
                          class: "tw-align-middle"
                        }, [
                          _createElementVNode("td", _hoisted_11, [
                            _createVNode(_component_EditableInputLabel, {
                              label: _ctx.editingRate.id === rate.id ? 'Rate Name' : undefined,
                              isEditing: _ctx.editingRate.id === rate.id,
                              "model-value": 
                      _ctx.editingRate.id === rate.id
                        ? _ctx.editingRate.destinationCity
                        : rate.destinationCity
                    ,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editingRate.destinationCity = $event))
                            }, null, 8, ["label", "isEditing", "model-value"])
                          ]),
                          (_ctx.editingRate.id !== rate.id)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.rateChargeString(rate)), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_14, [
                                _createVNode(_component_EditableInputLabel, {
                                  isEditing: true,
                                  label: "Rate Amount",
                                  modelValue: _ctx.editingRate.amount,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingRate.amount) = $event))
                                }, null, 8, ["modelValue"])
                              ])),
                          _createElementVNode("td", _hoisted_15, [
                            (_ctx.editingRate.id === rate.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createVNode(_component_Button, {
                                    isGreen: true,
                                    icon: "check",
                                    onClick: _ctx.editRateCategory
                                  }, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                      _createTextVNode("Save", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_Button, {
                                    isRed: true,
                                    isSecondary: true,
                                    onClick: _ctx.cancelEditRateCategory
                                  }, {
                                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                      _createTextVNode(" Cancel ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _withDirectives((_openBlock(), _createElementBlock("button", {
                                    type: "button",
                                    class: "tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-500 hover:tw-bg-slate-100 hover:tw-text-slate-900",
                                    onClick: ($event: any) => (_ctx.startEditRateCategory(rate))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "pen-to-square",
                                      class: "tw-h-3.5 tw-w-3.5"
                                    })
                                  ], 8, _hoisted_18)), [
                                    [_directive_tippy, 'Edit']
                                  ]),
                                  _withDirectives((_openBlock(), _createElementBlock("button", {
                                    type: "button",
                                    class: "tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-500 hover:tw-bg-rose-50 hover:tw-text-rose-700",
                                    onClick: ($event: any) => (_ctx.deleteRate(rate))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "trash",
                                      class: "tw-h-3.5 tw-w-3.5"
                                    })
                                  ], 8, _hoisted_19)), [
                                    [_directive_tippy, 'Delete']
                                  ])
                                ]))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, "No rates yet."))
          ]),
          _createElementVNode("section", _hoisted_21, [
            _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "tw-mb-2 tw-text-lg tw-font-semibold tw-text-slate-900" }, "Billing", -1)),
            _createElementVNode("p", _hoisted_22, [
              _cache[11] || (_cache[11] = _createTextVNode(" Total receivable: ", -1)),
              _createElementVNode("span", _hoisted_23, " $" + _toDisplayString(Number(_ctx.totalReceivable || 0).toFixed(2)), 1)
            ])
          ])
        ]))
  ]))
}